import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

const CONSENT_KEY = "metrosenda_consent_v2";
const BANNER_KEY = "metrosenda_cookie_seen";

function updateGtagConsent(granted) {
  const state = granted
    ? {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
      }
    : {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
      };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(state));
    localStorage.setItem(BANNER_KEY, "1");
  } catch (e) {
    // storage may be unavailable (SSR, private mode)
  }
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", state);
  } else if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
    window.dataLayer.push(["consent", "update", state]);
  }
}

export default function CookieBanner() {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem(BANNER_KEY);
      if (!seen) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    updateGtagConsent(true);
    setVisible(false);
  };
  const handleReject = () => {
    updateGtagConsent(false);
    setVisible(false);
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0F172A] text-white"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex-1">
          <p className="text-sm font-semibold text-white mb-1">
            {t("cookie_banner.title")}
          </p>
          <p className="text-xs md:text-sm text-slate-300 leading-relaxed">
            {t("cookie_banner.body")}{" "}
            <Link
              to={`/${lang}/cookies`}
              className="underline underline-offset-2 hover:text-white"
              data-testid="cookie-banner-policy-link"
            >
              {t("cookie_banner.manage")}
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <button
            type="button"
            onClick={handleReject}
            className="px-5 py-3 text-sm font-semibold border border-white/30 text-white hover:bg-white/10"
            data-testid="cookie-banner-reject"
          >
            {t("cookie_banner.reject_all")}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-5 py-3 text-sm font-semibold bg-[#B48E5D] text-[#0F172A] hover:bg-[#c9a06a]"
            data-testid="cookie-banner-accept"
          >
            {t("cookie_banner.accept_all")}
          </button>
        </div>
      </div>
    </div>
  );
}
